import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { BlogLoginResp } from 'src/app/models/common/BlogLoginResp';
import { CompanyLoginResp } from 'src/app/models/common/CompanyLoginResp';
import { SubscriberLoginResp } from 'src/app/models/common/SubscriberLoginResp';
import { ALL_KNOWN_API_BASE_URLS } from 'src/environments/api-urls';
import { RuntimeConfigService } from 'src/app/services/app/runtime-config.service';

@Injectable()
export class CommonInterceptor implements HttpInterceptor {
  private apiBaseUrl: string = '';

  constructor(
    private cookieService: CookieService,
    private configService: RuntimeConfigService
  ) {
    this.configService.apiUrl$.subscribe((url) => {
      this.apiBaseUrl = url;
    });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const blogUserString = sessionStorage.getItem('blogUser');
    const companyUserString = sessionStorage.getItem('companyUser');
    const companyToken = sessionStorage.getItem('ctoken');
    let subscriberString = sessionStorage.getItem('subscriber');
    const subscriberToken = sessionStorage.getItem('token');
    const cookieToken = this.cookieService.get('token');

    if (!subscriberString) {
      subscriberString = this.cookieService.get('subscriber');
    }

    let blogToken: string | null = null;
    let companyUserToken: string | null = null;
    let subscriberUserToken: string | null = null;

    if (blogUserString) {
      const user: BlogLoginResp = JSON.parse(blogUserString);
      blogToken = user?.token ?? null;
    }

    if (companyUserString) {
      const user: CompanyLoginResp | number = JSON.parse(companyUserString);
      companyUserToken = typeof user === 'object' && user ? user.token : null;
    }

    if (subscriberString) {
      const user: SubscriberLoginResp = JSON.parse(subscriberString);
      subscriberUserToken = user?.token ?? null;
    }

    const finalToken =
      companyToken ||
      companyUserToken ||
      blogToken ||
      subscriberToken ||
      subscriberUserToken ||
      cookieToken ||
      null;

    if (finalToken && finalToken !== 'undefined' && finalToken !== 'null') {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${finalToken}`,
        },
      });
    }

    // let tokenizedReq = request.clone({
    //   setHeaders:{
    //     Authorization : `Bearer ${this.authService.getToken()}`
    //   }
    // });

    if (this.apiBaseUrl) {
      let url = request.url;
      for (const knownBase of ALL_KNOWN_API_BASE_URLS) {
        if (knownBase !== this.apiBaseUrl && url.includes(knownBase)) {
          url = url.split(knownBase).join(this.apiBaseUrl);
        }
      }
      if (url !== request.url) {
        request = request.clone({ url });
      }
    }

    return next.handle(request);
  }
}
